export default {
    CONSOLIDATE_TRUE: "true",
    CONSOLIDATE_FALSE: "false"
};